import React from 'react';
import styled from 'styled-components';
import FormStylesOptions from '../../../constants/FormStylesOptions';

const selectStyles = (props) => {
  return `
    height: 100%;
    width: 100%;
    background-color: ${props.backgroundColor};
    font-size: ${props.fontSize}px !important;
    color: ${props.fontColor};
    font-style: ${props.fontStyle};
    font-weight: ${props.fontWeight};
    text-align: ${props.textAlign};
    text-transform: ${props.textTransform};
    text-decoration: ${props.textDecoration};
    border-radius: ${props.borderRadius}px;
    border: ${props.border};
    padding: ${props.padding}px;
    transition: all 0.15s ease-in-out;

    text-overflow: ${(props.textOverflow === FormStylesOptions.textOverflowEllipsis ? 'ellipsis' : 'normal')};
    white-space: ${(props.textOverflow === FormStylesOptions.textOverflowEllipsis ? 'nowrap' : 'normal')};
    overflow: ${(props.textOverflow === FormStylesOptions.textOverflowEllipsis ? 'hidden' : 'visible')};
  `;
};

const StyledSelect = styled.select`

  ${(props) => selectStyles(props)}

  &:focus, &:focus-visible {
    outline: unset;
    border: ${(props) => props.borderWidth}px solid ${(props) => props.primaryColor};
  }

  &:hover {
    cursor: pointer;
    ${(props) => (props.disabled ? '' : `border: ${props.borderWidth}px solid ${props.primaryColor}`)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 1;
  }

`;

const StyledSpan = styled.span`
  ${(props) => selectStyles(props)}
  overflow: hidden;
`;

/**
 * This components main purpose is to isolate the input
 * styles into one location and not require style updates
 * all over the place when we update it in the future.
 */
const FieldGenericSelect = (props) => {

  const { borderWidth, borderColor, options, value, disabled, selectRef, ...rest } = props;

  /**
   * We join width and color to a single border style because chrome displays
   * the border as a two tone color if you use border-color and border-width
   * indvidually.
   */
  const border = `${borderWidth}px solid ${borderColor}`;

  if (disabled) {
    const selectedOption = !options || options.length < 1 || !value ? null :
    options.find((option) => { return option._id === value; });
    return (
      <StyledSpan {...rest} border={border} data-field-generic-select-readonly="true">
        <span>{selectedOption ? selectedOption.value : ''}</span>
      </StyledSpan>
    );
  }


  /**
   * Handling Disabled State
   * 
   * Below notes are made as of Sep 25, 2025 regarding the following notion task: NO-1326
   * 
   * * Why aren't we using the native html select with disabled instead of using a span?
   *  - The reason is because the native html select with disabled still has a chevron visible. This causes
   *    issues with very small select boxes on PDF Forms to have the text cut off. I (josh) tried removing the 
   *    chevron using the "appearance: none" css property (recommended and only real approach) but it has too many
   *    negative and conflighting side effects with our own internal styles.
   */
  const optionNodes = [];
  if (options && options.length > 0) {
    options.forEach((option) => {
      if (option.deleted) return;
      optionNodes.push(
        <option key={option._id} value={option._id}>
          {option.value}
        </option>
      );
    });
  }
  
  return (
    <StyledSelect {...rest} ref={selectRef} border={border}>
      <option value="" />
      {optionNodes}
    </StyledSelect>
  );

};

export default React.memo(FieldGenericSelect);
